import PropTypes from 'prop-types'
import { CourseSubType } from './data'

export const MARKETING_CONTENT_TYPE = PropTypes.shape({
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  instructorName: PropTypes.string.isRequired,
  trailerId: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
})

export type MarketingSectionItem = {
  title: string
  subtitle: string | null
  instructorName: string
  trailerId: string
  slug: string
  videoId?: string | number | null
  mediaUuid: string
  type: string | null
  id: string
  tag: string
  link: string
  duration: number
  nameplateImage: string | null
  primary16x9: string | null
  primary2x3: string | null
  primary16x9AltText: string | null
  primary2x3AltText: string | null
  primary1x1: string | null
  backgroundImage: string
  backgroundImageAltText: string | null
  verticalBackgroundImage: string
  verticalBackgroundImageAltText: string | null
  metaDescription: string | null
  releaseDescription: string | null
}

export const MARKETING_DATA_TYPE = PropTypes.shape({
  slug: PropTypes.string.isRequired,
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  marketingSectionItems: PropTypes.array.isRequired,
})

export type MarketingSectionAction = {
  slug: string
  title: string
  subtitle: string
  link: string
  cta: string
}

export type MarketingDataType = {
  slug: 'featured-instructor' | 'trending' | 'coming-soon'
  id: number | string
  marketingSectionItems: MarketingSectionItem[]
  marketingSectionAction?: MarketingSectionAction
}

export const MARKETING_ROWS_DATA_TYPE = PropTypes.arrayOf(MARKETING_DATA_TYPE)

export const SLIDE_TYPE = PropTypes.shape({
  slug: PropTypes.string.isRequired,
  primary1x1: PropTypes.string.isRequired,
  primary2x3: PropTypes.string.isRequired,
  primary16x9: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  nameplateImage: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  tag: PropTypes.string.isRequired,
})

type SlideType = CourseSubType | 'camp'

export type Slide = {
  id: string | number
  slug: string
  primary1x1: string
  primary1x1AltText: string | null
  primary2x3: string
  primary16x9: string
  link: string
  nameplateImage: string
  instructorName: string
  title: string
  subtitle: string
  tag: string
  releaseDescription: string | null
  metaDescription: string | null
  type: SlideType
  videoId: number | string | null
  mediaUuid: string | undefined
}

export const FEATURE_INSTRUCTOR_CONTENT_TYPE = PropTypes.shape({
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  marketingSectionItems: PropTypes.arrayOf(SLIDE_TYPE),
  slug: PropTypes.string.isRequired,
})

export type FeaturedInstructorContent = {
  id: number | string
  marketingSectionItems: Slide[]
  slug: string
}

export const STUDENT_STORY_MOBILE_TYPE = PropTypes.shape({
  studentName: PropTypes.string.isRequired,
  location: PropTypes.string.isRequired,
  quote: PropTypes.string.isRequired,
  studentPicUrlMobile: PropTypes.string.isRequired,
})

export const SESSIONS_TILE_TYPE = PropTypes.shape({
  backgroundImage: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
})

export const TILE_TYPE = PropTypes.shape({
  backgroundImage: PropTypes.string,
  id: PropTypes.string.isRequired,
  link: PropTypes.string,
  slug: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  tag: PropTypes.string,
  title: PropTypes.string,
})

export const TRENDING_TILE_TYPE = PropTypes.oneOfType([
  TILE_TYPE,
  SESSIONS_TILE_TYPE,
])

export const DISCOUNT_TYPE = PropTypes.shape({
  error: PropTypes.string,
  amountOff: PropTypes.number,
  slug: PropTypes.string,
  description: PropTypes.string,
  discountValue: PropTypes.string,
  discountHeadline: PropTypes.string,
  discountType: PropTypes.string,
  percentageOff: PropTypes.number,
  type: PropTypes.string,
  promoStatus: PropTypes.string,
  upsellText: PropTypes.string,
})
